module.exports = __webpack_public_path__ + "static/media/ac-delete.3090ad3c.svg";